{
    "PartitionList_Column_Description": "Description",
    "PartitionList_Column_IDInTelSys": "IDENTIFIANT",
    "PartitionList_Column_Licence": "Licence",
    "PartitionList_Column_Extensions": "Extensions",
    "PartitionList_Column_AcdAgents": "Agents",
    "PartitionList_Column_AppUsers": "Utilisateurs",
    "PartitionList_Column_SyncType": "Type de synchronisation",
    "PartitionList_Column_Status": "Statut",
    "PartitionList_Filter_Licence": "Licence",
    "PartitionList_CountLink_ExtensionsAria": "Afficher les périphériques de cette partition",
    "PartitionList_CountLink_AcdAgentsAria": "Afficher les agents ACD dans cette partition",
    "PartitionList_CountLink_AppUsersAria": "Afficher les utilisateurs de l'application dans cette partition",
    "PartitionList_Add_Disabled_SelectTelephonyServer": "Sélectionnez un serveur de téléphonie pour ajouter une partition.",
    "NAME": "Langue de la liste de partition"
}